import { callAPI } from "features/yard360/store/helpers/apiCaller";
import { APIS } from "app/app-config";
import {
  FETCH_FEATURE_FLAGS,
  FETCH_FEATURE_FLAGS_SUCCESS,
  FETCH_FEATURE_FLAGS_FAILURE,
} from "features/yard360/store/featureFlags/types";

/**
 * Fetches the whole feature-flag set in a SINGLE IsFeatureEnabled call
 * (request.features / response.features — the batch shape in
 * YTYardConsoleServiceModel; the single-feature attribute is deprecated).
 *
 * YDLR yard features ride along in the same call (request.yardFeatures /
 * response.yardFeatures) and land in the same store, keyed by their
 * YardFeature enum name. They are only requested when a building code is
 * available to send as yardId — YardConsole fails the whole call if
 * yardFeatures is sent without one.
 *
 * @param {string[]} features flag keys to query
 * @param {string[]} [yardFeatures] YDLR yard feature names to query
 */
export const fetchAllFeatureFlags = (features, yardFeatures = []) => {
  return async (dispatch, getState) => {
    const { activeBuildingCode } = getState().authInfo;
    const requestedYardFeatures = activeBuildingCode ? yardFeatures : [];
    const allFeatures = [...features, ...requestedYardFeatures];
    dispatch(fetchFeatureFlagsRequest(allFeatures));

    try {
      const response = await callAPI(getState().authInfo, APIS.IsFeatureEnabled, {
        features,
        ...(activeBuildingCode && { yardId: { buildingCode: activeBuildingCode } }),
        ...(requestedYardFeatures.length > 0 && { yardFeatures: requestedYardFeatures }),
      });

      dispatch(
        fetchFeatureFlagsSuccess([...(response?.features ?? []), ...(response?.yardFeatures ?? [])])
      );
    } catch (e) {
      dispatch(fetchFeatureFlagsFailure(allFeatures, e.message));
    }
  };
};

export const fetchFeatureFlagsRequest = (features) => {
  return {
    type: FETCH_FEATURE_FLAGS,
    payload: { features },
  };
};

/**
 * @param {Array<{ feature: string, enabled: boolean }>} features enablement states
 */
export const fetchFeatureFlagsSuccess = (features) => {
  return {
    type: FETCH_FEATURE_FLAGS_SUCCESS,
    payload: { features },
  };
};

export const fetchFeatureFlagsFailure = (features, errorMessage) => {
  return {
    type: FETCH_FEATURE_FLAGS_FAILURE,
    payload: { features, errorMessage },
  };
};
